import RouteContainer from 'containers/RouteContainer';
import Component from './containers/NextContainer';

export const path = `${DOCUMENTS_PATH}/next`;
export const navigation = { name: 'next', id: 'next.title', nonNavigable: true };

export default RouteContainer(path, Component);
